module.exports = __webpack_public_path__ + "assets/img/开发及兼容性好.3ca7f3ea.jpg";